import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class FaultDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"FAUTE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "FAUTE",
            player: event.detail?.player,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player"].includes(key)){
            let commentaire = "Faute"

            const faultPlayer = getPlayer(this.player, match)
            const team = getTeam(this.team, match)

            if(this.player){
                if(faultPlayer){
                    commentaire += ' de '+ faultPlayer.lastname
                }
            }else if(team){
                commentaire += ' de '+ team.name
            }

            commentaire += "! "
            
            this.text = commentaire
        }
    }
}